import { brand } from '#brand/design-system/colors.json'
import type { RecursivePartial } from '#types/utils'
import type { VfConfig } from '#types/config/components/vf'

export default {
  ctaTheme: brand['4'],
} satisfies RecursivePartial<VfConfig['footerLoyalty']>
